<!--
 * @Author: chenjianxiong 2232943862@qq.com
 * @Date: 2025-09-30 09:12:51
 * @LastEditors: chenjianxiong 2232943862@qq.com
 * @LastEditTime: 2025-11-20 10:06:30
 * @FilePath: \itos-front-ysedu\src\views\web\text.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="social-asset-page">
    <FilterBar :dataList="filterList" @change="changeQuery" @clearAll="clearAll" />
    <div id="target" style="
                  display: flex;
                  height: 100%;
                  justify-content: space-around;
                  width: 1400px;
                  flex-wrap: wrap;
                ">
      <div style="
                    display: flex;
                    width: 1350px;
                    flex-wrap: wrap;
                    margin-right: 32px;
                  ">
        <div class="rent-content ml15 mt20 uball shouzhi" v-for="(option, index) in dataList" :key="index"
          style="width: 315px; height: 290px" @click="clice(option.id)">
          <!-- text -->
          <div class="bg-c lh-180">
            <img style="width: 100%; height: 100%; object-fit: cover" :src="option.picture
              ? option.picture
              : require('@/assets/image/icon_Cumulative2.png')
              " alt="社会资产" />
          </div>

          <div class="rent-content-title ml20 mt10 el-1" @click="clice(option.id)">
            {{ option.assetName }}
          </div>
          <div class="rent-content-price">
            <div class="rent-content-price1 ml20 mt5">
              {{ option.price ? option.price : "-"
                        }}<span style="padding-left: 4px;">{{ option.priceUnit }}</span>
            </div>
          </div>
          <div>
            <div class="mt10 flex">
              <div class="mt10 ml20" style="color: #65686d">
                 {{ option.quantity ? option.quantity : "-"
                        }}{{ option.quantityUnit }}
              </div>
              <div class="rent-content-price2 shouzhi mr20 mt5" v-if="rentStatus.length > 0" :class="option.rentStatus == 1 ? 'ing' : 'end'">
                {{ selectDictLabel(rentStatus, option.rentStatus) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="pageParams.total <= 0">
      <el-empty description="暂无数据" />
    </div>
    <div class="pagination" v-show="pageParams.total > pageSize" style="justify-content: center;display: flex;">
                  <!-- 分页选择 -->
                  <div class="mb20 mt20">
                    <el-pagination small
                                    background
                                    layout="total, sizes, prev, pager, next, jumper, ->"
                                    class="mt-4 mt10"
                                    :size="pageParams.pageSize"
                                    v-model:page-size="pageParams.pageSize"
                                    :page-sizes="[8,16,24]"
                                    :total="pageParams.total"
                                    @current-change="changePageIndex"
                                     @size-change="changePageSize"
                                    :current-page="pageParams.pageNum" />
                  </div>
                </div>
  </div>

</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import FilterBar from "./FilterBar";
import { getSocialAssetPage } from "@/api/socialAsset";
import { getDistTypesData } from "@/api/tool";
import { selectDictLabel,handleSocialAssetRoute } from "@/util/utils";
import { useRouter } from "vue-router";
const props = defineProps({
  filterList: {
    type: Array,
    required: true
  }
});
const pageParams = reactive({
  pageNum: 1,
  pageSize: 8,
  total: 0
})
const pageSize = ref(8)
let router = useRouter();
const rentStatus = reactive([])
const dataList = reactive([])
const queryParams = reactive({
  pageNum: '',
  pageSize: '',
  province: '',
  city: '',
  region: '',
  assetType: '',
  assetClassify: '',
  quantityQuery: '',
  quantityStart: '',
  quantityEnd: '',
  priceQuery: '',
  priceStart: '',
  priceEnd: '',
  publishTimeQuery: '',
  publishTimeStart: '',
  publishTimeEnd: '',
  info: '',
})
const changeQuery = (e) => {
  console.log("接收到参数", e);
  // iconss.current = 1;
  // iconss.themeQueryArray = e.themeQueryArray;
  // iconss.rentTypeQueryArray = e.rentTypeQueryArray;
  // iconss.bidTypeArray = e.bidTypeArray;
  // iconss.regionArray = e.regionArray;
  // iconss.bidTimeQuery = e.bidTimeQuery;
  // iconss.bidPriceQuery = e.bidPriceQuery;
  // iconss.cityArray = e.cityArray;
  // data.bidEndPrice = e.bidEndPrice;
  // data.bidStartPrice = e.bidStartPrice;
  // data.beginBidTime = e.beginBidTime;
  // data.endBidTime = e.endBidTime;
  // data.text = e.bidCodeOrName;
  getSocialPage({
    ...pageParams,
    ...e
  });
};
let clice = function (id) {
 handleSocialAssetRoute(id,router)
};

const getSocialPage = async (params) => {
  getSocialAssetPage(params).then((res) => {
    if (res.code === 200) {
      dataList.splice(0, dataList.length, ...res.data.records)
      pageParams.total = res.data.total;
    }
  })
}
const changePageIndex = (pageNum)=>{
  pageParams.pageNum = pageNum
  changeQuery()
}

const changePageSize =(size)=>{
  pageParams.pageSize = size
  changeQuery()
}
onMounted(async () => {
  getDistTypesData(['asset_rent_status']).then(res => {
    rentStatus.splice(0, rentStatus.length, ...res.data[0].dictData)
  })
})
</script>

<style lang="scss">
.social-asset-page {
  .rent-content {
    &-title {
      font-size: 20px;
      color: #333333;
      font-weight: bold;
      margin-bottom: 4px;
    }

    &-price {
      display: flex;

      justify-content: space-between;
      align-items: center;

      &1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #d2a04d;
        font-size: 18px;

        &1 {
          font-size: 14px;
        }
      }

      &2 {
        background: #c08c58;
        color: #ffffff;
        font-size: 14px;
        padding: 4px 12px;
        border-radius: 4px;
        margin-left: auto;
      }
    }

    .el-tag .is-closable {
      --el-tag-bg-color: var(--el-color-warning-light-9) !important;
    }
    .flex{
      display: flex;
    }
     & .ing {
        background: #C08C58;

      }

      & .end {
        background: #C8C9CC;
      }
  }
}
</style>
